import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Root = styled(({ children, inIframe, ...props }) => <div {...props}>{children}</div>)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: auto;
  width: 100%;
`

export const Header = styled('section')`
  margin: 0;
  width: 100%;
`

export const TopContent = styled('section')`
  width: 100%;
`

export const Body = styled(BaseGrid)`
  &.MuiGrid-root .container-body {
    display: flex;
    height: auto;
    padding: 0;
    width: 100%;
  }
`

export const Container = styled('section')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: auto;
  padding: 0 18px;
  width: 100%;

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 540px;
  }

  ${props => props.theme.breakpoints.only('sm')} {
    max-width: 720px;
  }

  ${props => props.theme.breakpoints.only('md')} {
    max-width: ${props => (props.inIframe ? '1140px' : '960px')};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 1440px;
    padding: 0;
  }
`

export const Section = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: 0 0 20px;
  }
`

export const Footer = styled('section')`
  margin: 0;
  width: 100%;
`
